// Libs
import Translation from 'libs/Translation';

// Components
import Text from 'components/common/Text';
import Link from 'components/common/Link';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const Specialty = ({ doctor, webConfig }) => {

    return (
        <div className="box">
            <Text 
                tag="h2"
                color="#0D2439"
                className="title"
            >
                {Translation.t('title.specialty')}
            </Text>
            {doctor.specialtyDetails?.length &&
            <div className='list'>
                {doctor.specialtyDetails.map((s, index) => (
                    <div className='row-flex gap-5 '>
                    <div 
                        className='row-flex gap-8-center'
                        key={index}
                    >
                        <div 
                            className='filled-circle' 
                        />
                        <Text 
                            tag="h3"
                            color="#61788E"
                            className="margin-1"
                        >
                            {Translation.t('label.specialty-education', {degree: s.EducationLevel, specialty: s.Specialty})}
                        </Text>
                    </div>
                    <Link 
                        key={index}
                        className='row-flex gap-8'
                        to={`/explore/doctors/all/${s?.SpecialtySlug}/city/IR`}
                        params={webConfig.lang !== 'fa' ? {lang: webConfig.lang} : {}}
                    >
                        <div className='view-button'>
                            (
                            <div className='label'>
                                {Translation.t('label.view-all')} 
                            </div>
                            {webConfig.dir === 'rtl' 
                            ?
                            <ArrowBackIcon className='icon'/> 
                            :
                            <ArrowForwardIcon className='icon'/>
                            })
                        </div>
                    </Link>
                    </div>
                ))}
            </div>
            }
        </div>
    )
}
export default Specialty;